<script>
import { Pie } from "vue-chartjs";
import pluginConfig from "../../services/graphPlugins.js";

export default {
  extends: Pie,
  props: {
    data: { type: Object, required: true }
  },
  data() {
    return {
      feedIndex: 0,
      highestValue: 0
    };
  },
  watch: {
    data: {
      async handler() {
        await this.renderGraph();
      }
    }
  },
  async mounted() {
    await this.addPlugin(pluginConfig.labelOutside(this._data._chart));
    await this.renderGraph();
  },
  methods: {
    graphData() {
      return {
        labels: this.data.labels,
        datasets: this.data.datasets.map(set => ({
          label: "Label",
          borderWidth: 2,
          pointBorderWidth: 1,
          pointRadius: 1,
          pointHoverRadius: 5,
          pointHitRadius: 10,
          backgroundColor: set.color,
          data: set.values,
          lineTension: 0.2,
          hoverBackgroundColor: set.color
        }))
      };
    },
    renderGraph() {
      const context = this;
      this.renderChart(this.graphData(), {
        animation: false,
        tooltips: {
          xAlign: "center",
          displayColors: false,
          bodyFontColor: "white",
          bodyFontSize: 13,
          bodyFontStyle: "normal",
          backgroundColor: "transparent",
          caretSize: 0,
          callbacks: {
            label(ti, data) {
              const unit = data.datasets[ti.datasetIndex].data[ti.index];
              if (!unit) {
                return;
              }
              return unit + (context.data.unit || "");
            },
            title() {
              return;
            }
          }
        },
        title: {
          display: !!context.data.title,
          text: context.data.title
        },
        legend: {
          display: true,
          position: context.data.legendPosition || "top",
          labels: {
            padding: 12
          },
          onClick: () => ({})
        },
        layout: { padding: { top: 0 } },
        responsive: true,
        maintainAspectRatio: false,
        showAllTooltips: true,

        onClick: (_, arr) => {
          this.$nextTick(() => {
            if (arr.length && !isNaN(arr[0]._index)) {
              this.$emit(
                "onDataClick",
                arr[0],
                this.feedIndex,
                this.data.labels[arr[0]._index]
              );
            }
          });
        }
      });
    }
  }
};
</script>
